<style scoped lang="less">
.issueentry-text {
    white-space: pre-wrap;
}
.commentHeader {
    font-size: 1.2em;
}
.issue-group {
    margin-bottom: 20px;
}
.elementSchemaLabel {
    margin: 0;
}
.submissions-comment {
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    .comment-text {
        margin: 0;
    }
    .help-block {
        white-space: nowrap;
        display: block;
    }
    &:first-of-type {
        margin-top: 0;
    }
}
</style>
<template>
    <div>
        <ul class="comment-list">
            <li class="issue-group" v-for="(element, elementIndex) in allElementsWithIssues">
                <h3 class="d-block commentHeader">
                    <div class="fw-600">{{ element.getLabel() || "Unlabeled" }}</div>
                    <Promised :pending-delay="null" :promise="getSchemaLabel(element)" v-slot="data">
                        <div v-show="data != 'Page Set'" class="elementSchemaLabel editor-help-text">
                            {{ data }}
                        </div>
                    </Promised>
                </h3>
                <ol reversed class="comment-list">
                    <li class="submissions-comment" v-for="(issueEntry, issueIndex) in orderByDateDesc(element.issues)">
                        <!--
                        <strong class="fw-600">{{ issueEntry.userName || "Anonymous" }}</strong>
                        -->
                        <span class="help-block p-0">{{ new Date(issueEntry.activatedDate).toLocaleString() }}</span>
                        <!-- TODO only if reviewer? -->
                        <div class="issueentry-text">{{ issueEntry.adminDisplayLabel }}</div>
                        <div class="issueentry-text">{{ issueEntry.description }}</div>

                        <div class="mt-2">
                            <button class="btn btn-sm btn-outline-secondary cancel dfNavButton mb-1 mr-2" :id="`retry_${elementIndex}_${issueIndex}`" type="button" @click="retry(element, issueEntry)">
                                Retry
                                <AsyncOperationStatus :promise="retryPromise" v-if="retryPromise != null" />
                            </button>
                            <button class="btn btn-sm btn-outline-secondary cancel dfNavButton mb-1" :id="`skip_${elementIndex}_${issueIndex}`" type="button" @click="skip(element, issueEntry)">
                                Skip
                                <AsyncOperationStatus :promise="skipPromise" v-if="skipPromise != null" />
                            </button>
                        </div>
                    </li>
                </ol>
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, ref /*, inject*/ } from "vue";
import { Promised } from "@/lib/Promised";
import { usePageStore } from "../pageState/store";
import { BaseElementDefBase } from "../elements/BaseElementDef";
//import StateFormDef from "../elements/StateFormDef";
import orderBy from "@/lib/orderBy";
import { FormIssue } from "@cs-ts/form-issue";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
//import { resendEmailInjectKey } from "../Page.3.vue.InjectKeys";
export default defineComponent({
    components: { Promised, AsyncOperationStatus },
    setup() {
        const pageStore = usePageStore();
        //const resendEmail = inject(resendEmailInjectKey)!;

        const allElementsWithIssues = computed(() => pageStore.allElementsWithIssues);

        const orderByDateDesc = (a: FormIssue[]): FormIssue[] => {
            return orderBy(a, (a: FormIssue, b: FormIssue) => {
                return a.activatedDate < b.activatedDate ? 1 : a.activatedDate > b.activatedDate ? -1 : 0;
            });
        };
        const getSchemaLabel = async (element: BaseElementDefBase) => {
            const schemaLabels = (await pageStore.getSchemaLabelMapping())!;
            return schemaLabels[element.definition.type!] || element.definition.type;
        };

        const retryPromise = ref<undefined | Promise<void>>(undefined);
        const retry = (element: BaseElementDefBase, _issue: FormIssue) => {
            // TODO invoke type should be from TS-CS map
            // TODO targetPath
            retryPromise.value = pageStore.invokeForm({ segment: null, type: "RetryBehavior", target: element.id!, targetPath: null!, targetPathArray: null!, data: null, assign: false, noWrite: false });
        };

        const skipPromise = ref<undefined | Promise<void>>(undefined);
        const skip = (element: BaseElementDefBase, _issue: FormIssue) => {
            // TODO invoke type should be from TS-CS map
            // TODO targetPath
            skipPromise.value = pageStore.invokeForm({ segment: null, type: "SkipBehavior", target: element.id!, targetPath: null!, targetPathArray: null!, data: null, assign: false, noWrite: false });
        };

        return {
            allElementsWithIssues,
            getSchemaLabel,
            orderByDateDesc,
            retry,
            retryPromise,
            skip,
            skipPromise,
        };
    },
});
</script>
